module.exports = __webpack_public_path__ + "img/TSN_05_02.dae70ac2.png";